module.exports = __webpack_public_path__ + "static/mockupweb-1@3x-9e38694bf376cef3845cfa67fc21edd2.png";